/**
 * <social-proof> — a carousel of expert review cards. "Read full review"
 * expands the card in place (toggles the line clamp); the label switches to
 * "Show less". Cards whose text isn't actually truncated hide the button.
 */
if (!customElements.get('social-proof')) {
  customElements.define(
    'social-proof',
    class SocialProof extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-sp-card]'));

        this.cards.forEach((card) => {
          const btn = card.querySelector('[data-sp-readmore]');
          if (!btn) return;
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle(card, btn);
          });
        });

        // Hide the button on cards whose review fits without truncation.
        this.refresh = this.refresh.bind(this);
        this.refresh();
        window.addEventListener('load', this.refresh);
        window.addEventListener('resize', this.debounce(this.refresh, 150));
      }

      toggle(card, btn) {
        const expanded = card.classList.toggle('sp-card--expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const label = btn.querySelector('[data-sp-more-label]');
        if (label) {
          label.textContent = expanded
            ? btn.getAttribute('data-sp-less') || 'Show less'
            : btn.getAttribute('data-sp-more') || 'Read full review';
        }
      }

      refresh() {
        this.cards.forEach((card) => {
          if (card.classList.contains('sp-card--expanded')) return;
          const text = card.querySelector('[data-sp-text]');
          if (!text) return;
          // 1px tolerance for sub-pixel rounding.
          const truncated = text.scrollHeight - text.clientHeight > 1;
          card.classList.toggle('sp-card--full', !truncated);
        });
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }
  );
}
